import React from 'react';
import { Phone, Calendar, Shield, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import { businessInfo } from '../mock/data';

const Hero = () => {
  const handleCallClick = () => {
    window.location.href = `tel:${businessInfo.phoneTel}`;
  };

  const handleBooking = () => {
    // Mock booking functionality - will be replaced with actual booking system
    alert('Booking system will be integrated. Thank you for your interest!');
  };

  return (
    <section className="relative bg-[#152238] text-white overflow-hidden">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20">
              <Shield className="w-4 h-4" />
              <span className="text-sm font-medium">Licensed & Trusted Nationwide</span>
            </div>

            <div className="space-y-6">
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight">
                {businessInfo.name}
              </h1>
              <p className="text-xl lg:text-2xl text-[#A8B5C8] font-light">
                {businessInfo.tagline}
              </p>
              <p className="text-lg text-[#A8B5C8] leading-relaxed">
                {businessInfo.description}
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                size="lg" 
                onClick={handleCallClick}
                className="bg-white text-[#3B5275] hover:bg-blue-50 font-semibold text-lg px-8 py-6 transition-all duration-300 hover:scale-105"
              >
                <Phone className="w-5 h-5 mr-2" />
                Call Now
              </Button>
              <Button 
                size="lg" 
                onClick={handleBooking}
                variant="outline"
                className="border-2 border-white text-white hover:bg-white hover:text-[#3B5275] font-semibold text-lg px-8 py-6 transition-all duration-300 hover:scale-105"
              >
                <Calendar className="w-5 h-5 mr-2" />
                Book Appointment
              </Button>
            </div>

            {/* Contact Info */}
            <div className="flex flex-wrap gap-6 pt-4 text-sm">
              <div className="flex items-center space-x-2">
                <Phone className="w-4 h-4 text-[#A8B5C8]" />
                <span className="text-[#A8B5C8]">{businessInfo.phone}</span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin className="w-4 h-4 text-[#A8B5C8]" />
                <span className="text-[#A8B5C8]">Operating in 16 states</span>
              </div>
            </div>
          </div>

          {/* Right Content - Feature Cards */}
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 hover:bg-white/15 transition-all duration-300 hover:scale-105 col-span-2" data-testid="hero-families-helped-card">
              <div className="text-4xl font-bold mb-2">1,200+</div>
              <div className="text-sm text-[#A8B5C8]">Families Helped</div>
            </div>
            <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 hover:bg-white/15 transition-all duration-300 hover:scale-105 col-span-2" data-testid="hero-carriers-card">
              <div className="text-3xl font-bold mb-2">All Major Carriers</div>
              <div className="text-sm text-[#A8B5C8]">Complete coverage options - you won't miss out</div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
          <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="#F9FAFB"/>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
